import script from "./Accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=360a25be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360a25be"]])

export default __exports__